import React from 'react';
import { DateFormater } from "../../../services/DateFormater";
import { SpheraChip } from "@sphera-cloud/component-ui-reactjs";

const escapeRegExp = (text) => {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function TextCell(props) {
    const { formatDate } = DateFormater();
    const checkHTML = function (html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        return (doc.innerHTML === html);
    }

    var regEx = new RegExp("(" + escapeRegExp(props.searchedPhrase) + ")", "ig");
    let boldedText = props.DisplayValue;
    let title = props.DisplayValue;
    if (title != null && title.includes != null && title.includes("<div"))
        title = null;

    if (props.DisplayValue != null && props.searchedPhrase != null && props.searchedPhrase != "")
        boldedText = props.DisplayValue.toString().replace(regEx, '<b>$1</b>');

    if (boldedText != null && typeof (boldedText) == "string" && !checkHTML(boldedText))
        boldedText = props.DisplayValue;

    if (props.isDate && props.DisplayValue != null && typeof props.DisplayValue.getMonth === 'function') {
        let timeExists = props.DisplayValue.toLocaleTimeString() !== "12:00:00 AM";
        let includeTime = timeExists || props.adjustTimezone === 'true';
        let dateText = formatDate(props.DisplayValue, props.customer.DateFormatId, includeTime);
        boldedText = dateText;
        title = dateText;
    }

    if (props.isMenu) {
        return (<td><span className="recordMenu" onClick={(e) => props.linkClick(props.clickId, e, true)}
            onKeyDown={props.isLink && props.clickId != null ? (e) => { if (e.code === "Enter") props.linkClick(props.clickId) } : null}><i className="icon-ui-general-three-dots-vertical"></i></span>
        </td>);
    }

    if (props.isCheckbox) {
        return (<td><input type="checkbox" className="k-checkbox k-checkbox-md k-rounded-md" role="checkbox" aria-checked="true"
            checked={props.DisplayValue} onChange={(e) => props.checkboxChange(props.clickId, e.target.checked)} /></td>);
    }

    if (props.isBool) {
        return (<td>{props.DisplayValue == 1 ? <i className="icon-ui-general-check" style={{ verticalAlign: "sub", background: "#33BB44" }} ></i> : ""}</td>);
    }
    if (props.field === "expiredAt") {
        return (<td>{<SpheraChip
            text={title === null ? props.noExpiratonLocalization : title}
            color={title === null ? "green" : new Date(title) < new Date(Date.now()) ? "red" : new Date(new Date(new Date(title)).setDate(new Date(title).getDate() - 30)) < new Date(Date.now()) ? "yellow" : "blue"}
            removable={false}
            tooltipTitle={title === null ? props.noExpiratonLocalization : new Date(title) < new Date(Date.now()) ? props.expiredLocalization : new Date(new Date(new Date(title)).setDate(new Date(title).getDate() - 30)) < new Date(Date.now()) ? props.tokenExpirationWarning : title}
            tooltipPosition="bottom"/>}</td>);
    }

    return (
        <td> 
            {props.isCopy && <i className="icon-ui-general-copy" style={{ background: "#009BDE", marginLeft: "6px" }}
                onClick={props.isLink && props.clickId != null ? (e) => props.linkClick(props.clickId, e) : null}
                onKeyDown={props.isLink && props.clickId != null ? (e) => { if (e.code === "Enter") props.linkClick(props.clickId, e) } : null}            />
            }
            <span data-testid="gridLink" 
                    className={props.isLink && props.clickId != null ? "gridLink" : ""} 
                    onClick={props.isLink && props.clickId != null ? (e) => props.linkClick(props.clickId, e) : null}
                    onKeyDown={props.isLink && props.clickId != null ? (e) => { if (e.code === "Enter") props.linkClick(props.clickId, e) } : null}
                    dangerouslySetInnerHTML={{ __html: boldedText }}
                    onMouseMove={props.onMouseMove}
                    title={title}
                    ref={props.ref}>
            </span>
         </td>);
}
